import { Check } from 'lucide-react'
import { FOLDER_COLORS, VALID_COLORS } from './folderColors'

interface FolderColorPickerProps {
  currentColor: string
  onSelect: (color: string) => void
}

export function FolderColorPicker({ currentColor, onSelect }: FolderColorPickerProps) {
  return (
    <div className="flex flex-wrap gap-2 p-2 max-w-[160px]">
      {VALID_COLORS.map((color) => (
        <button
          key={color}
          type="button"
          className={`w-6 h-6 rounded-full cursor-pointer flex items-center justify-center
            ${FOLDER_COLORS[color].dot}
            ring-offset-2 hover:ring-2 hover:ring-current
            ${currentColor === color ? 'ring-2 ring-current' : ''}
          `}
          onClick={(e) => {
            e.stopPropagation()
            onSelect(color)
          }}
        >
          {currentColor === color && (
            <Check className="w-3 h-3 text-white" />
          )}
        </button>
      ))}
    </div>
  )
}
